import { FirebaseOptions, initializeApp } from 'firebase/app';
import { Analytics, getAnalytics, logEvent, setUserProperties } from 'firebase/analytics';
import { getBrowserAgent } from '@helpers/browser.helpers';
let analytics: Analytics;

const initFirebase = (config: FirebaseOptions) => {
	const app = initializeApp(config);
	analytics = getAnalytics(app);
	const { browserName, deviceType, os } = getBrowserAgent();
	setUserProperties(analytics, { browser_name: browserName, device_type: deviceType, os });
};

export { initFirebase, analytics, logEvent };
